import { render, staticRenderFns } from "./userAside.vue?vue&type=template&id=0ac3f1e4&scoped=true&"
import script from "./userAside.vue?vue&type=script&lang=js&"
export * from "./userAside.vue?vue&type=script&lang=js&"
import style0 from "./userAside.vue?vue&type=style&index=0&id=0ac3f1e4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac3f1e4",
  null
  
)

export default component.exports